<template>
  <Modal v-bind="$attrs" @cancel="$emit('update:visible', false), $emit('cancel')">
    <div class="step-indicator">
      <div class="step-item" :class="{ 'is-active': step === 1 }">
        <span class="num">1</span>
        <span class="text">输入优化指令</span>
      </div>
      <div class="icon el-icon-right"></div>
      <div class="step-item" :class="{ 'is-active': step === 2 }">
        <span class="num">2</span>
        <span class="text">对比并确认效果</span>
      </div>
    </div>

    <div class="prompt-box" v-if="step === 1">
      <p>请输入您的优化指令, AI将以当前脚本为基础进行重写。</p>
      <el-input v-model="optimization_instruction" type="textarea" placeholder="脚本需要 xxx" :rows="6" />
    </div>

    <div class="diff-box" v-if="step === 2">
      <el-card v-for="(shot, index) in shots" :key="index" class="box-card" shadow="never">
        <div slot="header">
          <span>分镜{{ index + 1 }}</span>
          <span>&emsp;{{ shot.time_range }}</span>
        </div>
        <div class="row-wrapper">
          <div class="row-left script-content">
            <div class="row-info">
              <h4>原始版本</h4>
              <el-radio v-model="shot.compareShotChecked" label="1">&ensp;</el-radio>
            </div>
            <div class="compare-content">
              <p><strong>画面描述：</strong>{{ shot.visual_core }}</p>
              <p><strong>台词：</strong>{{ shot.dialogue }}</p>
              <p><strong>叙事重点：</strong>{{ shot.content_narrative_focus }}</p>
              <p><strong>情感氛围：</strong>{{ shot.emotion_atmosphere }}</p>
              <p><strong>关键要素：</strong>{{ shot.key_elements }}</p>
            </div>
          </div>
          <div class="row-right script-content">
            <div class="row-info">
              <h4>优化版本</h4>
              <el-radio v-model="shot.compareShotChecked" label="2">&ensp;</el-radio>
            </div>
            <div class="compare-content">
              <p><strong>画面描述：</strong>{{ newShots[index].visual_core }}</p>
              <p><strong>台词：</strong>{{ newShots[index].dialogue }}</p>
              <p><strong>叙事重点：</strong>{{ newShots[index].content_narrative_focus }}</p>
              <p><strong>情感氛围：</strong>{{ newShots[index].emotion_atmosphere }}</p>
              <p><strong>关键要素：</strong>{{ newShots[index].key_elements }}</p>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <template #confirm-btn>
      <slot name="confirm-btn"></slot>
    </template>
  </Modal>
</template>

<script setup>
import { ref, computed } from 'vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  step: {
    type: Number,
    default: 1
  },
  shots: {
    type: Array,
    default: () => []
  },
  newShots: {
    type: Array,
    default: () => []
  }
})
// eslint-disable-next-line
const emit = defineEmits(['input'])
const optimization_instruction = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})
</script>

<style scoped lang="scss">
@import '~common/styles/element-ui/variables.scss';

.prompt-box {
  margin-top: 26px;
}
.step-indicator {
  width: 368px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon {
    font-size: 18px;
  }

  .step-item {
    white-space: nowrap;
    display: flex;
    align-items: center;
    color: #f2f5f9;
    font-weight: 700;
    padding: 8px 18px;
    border-radius: 100px;
    background: #f2f5f9;

    .num {
      font-size: 13px;
      text-align: center;
      line-height: 22px;
      color: #fff;
      background: #bbcce2;
      border-radius: 100px;
      height: 22px;
      width: 22px;
      display: inline-block;
      margin-right: 8px;
    }
    .text {
      color: #63748f;
    }
    &.is-active {
      background: #dbeaff;

      .text {
        color: $primary-color;
      }

      .num {
        background: $primary-color;
      }
    }
  }
}

.diff-box {
  margin-top: 20px;
  max-height: 400px;
  overflow: auto;
  ::v-deep .el-card {
    margin-bottom: 10px;

    .el-card__body {
      padding: 0;
    }

    .el-card__header {
      background: #f9fafd;
      padding: 10px 20px;
    }
  }
  .row-wrapper {
    display: flex;
    .script-content {
      padding: 15px 20px;
      flex-basis: 50%;
      flex: 1;
      &.row-right {
        background: #f6f9ff;
      }

      .row-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        h4 {
          font-size: 16px;
        }
      }

      .compare-content {
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
}
</style>
